// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1SSR6","col":"CardReaderDesc_col__3WT_t","label":"CardReaderDesc_label__X7N27"};